import type {
  JustificationCategory,
  JustificationStatus,
  JustificationStatusFilter,
} from '../../lib/api/justifications';

/**
 * Every `t()` key this module needs for the closed vocabularies
 * `justifications.ts` carries — the identical shape `escalationLabels.ts`
 * documents at length: `as const satisfies Record<...>` is what keeps a
 * template-literal key (`` t(`justifications.status.${x}`) ``) out of this
 * codebase. That form compiles but fails `npm run typecheck` against the
 * typed `t()` overloads `i18next.d.ts` installs, because TypeScript widens
 * the template to `string`, which is not a key `en.json`'s shape admits.
 * These objects are the one place each vocabulary is mapped to a literal
 * key, so every call site reads a literal rather than building one.
 */

export const STATUS_LABEL_KEY = {
  open: 'justifications.status.open',
  answered: 'justifications.status.answered',
  approved: 'justifications.status.approved',
  rejected: 'justifications.status.rejected',
} as const satisfies Record<JustificationStatus, string>;

/** The status-filter segmented control offers five values, `JustificationStatusFilter`'s own set — `all` included, unlike `STATUS_LABEL_KEY` above, which types only a ROW's own status. */
export const QUEUE_LABEL_KEY = {
  open: 'justifications.queue.open',
  answered: 'justifications.queue.answered',
  approved: 'justifications.queue.approved',
  rejected: 'justifications.queue.rejected',
  all: 'justifications.queue.all',
} as const satisfies Record<JustificationStatusFilter, string>;

export const QUEUE_EMPTY_KEY = {
  open: 'justifications.empty.open',
  answered: 'justifications.empty.answered',
  approved: 'justifications.empty.approved',
  rejected: 'justifications.empty.rejected',
  all: 'justifications.empty.all',
} as const satisfies Record<JustificationStatusFilter, string>;

export const CATEGORY_LABEL_KEY = {
  missed_call: 'justifications.category.missedCall',
  late_logs: 'justifications.category.lateLogs',
  other: 'justifications.category.other',
} as const satisfies Record<JustificationCategory, string>;
